export default "__VITE_ASSET__CWn4bZrT__"